import axios from "./axiosinstance";

const ProjectModuleApi = {

  list: () => axios.get("projectModules/list"),
  add: (payload) => axios.post("projectModules/add", payload),
  update: (payload) => axios.post("projectModules/update", payload),
  toggleStatus: (payload) => axios.post("projectModules/toggle-status", payload),
  remove: (payload) => axios.post("projectModules/delete", payload),
};

export default ProjectModuleApi;